import { Component, Input, ViewEncapsulation } from "@angular/core";

import { MobileComponent } from "../../../mobile/interface/mobile.component";
import { CommonModule } from "@angular/common";
import { IconComponent } from "../../../icon/icon.component";
import { MaterialModule } from "src/app/shared/module/material.module";

@Component({
  encapsulation: ViewEncapsulation.None,
  selector: "rfc-vehicle-column",
  templateUrl: "./vehicle-column.component.html",
  styleUrls: ["./vehicle-column.component.scss"],
  standalone: true,
  imports: [
    CommonModule,
    IconComponent,
    MaterialModule,
  ]
})
export class VehicleColumnComponent extends MobileComponent {
  @Input() vehicle;

  constructor() {
    super();
  }

  getBarClass(color, size) {
    return { backgroundColor: color, height: 100 / size + "%" };
  }
}
